import React, { FC, useState, useEffect, useMemo } from 'react';
import { Select, Radio, Tooltip, Icon } from 'udesk-ui';
import { getInspectionPointsInlinePointBySource } from 'src/api/inspectionPoints/inlinePoint/{source}';

interface TemplateProps {
    value?: number;
    onChange?: (value?: number) => void;
    source?: number;
    disabled?: boolean;
}

const Template: FC<TemplateProps> = (props) => {
    const { value, onChange, source, disabled = false } = props;
    const [inlinePoints, setInlinePoints] = useState<any>([]);
    const [inlinePointId, setInlinePointId] = useState<any>(undefined);

    useEffect(() => {
        getInspectionPointsInlinePointBySource({
            segments: {
                source: source!,
            },
        }).then((resp) => {
            if (Array.isArray(resp.data) && resp.data.length) {
                setInlinePoints(resp.data);

                const newInlinePoint = resp.data.find((i) =>
                    i.operators?.some((o) => o.id === value)
                );
                if (newInlinePoint) {
                    setInlinePointId(newInlinePoint.id);
                } else {
                    setInlinePointId(resp.data[0].id);
                }
            }
        });
    }, [source, value]);

    const options = useMemo(() => {
        const selectedInlinePoint = inlinePoints.filter((i) => i.id === inlinePointId);
        let ret: {
            value: number;
            label?: string;
            desc?: string;
        }[] = [];
        if (selectedInlinePoint.length) {
            ret =
                selectedInlinePoint?.[0]?.operators.map((i) => ({
                    ...i,
                    value: i.id,
                    label: i.name,
                })) || [];
        }
        return ret;
    }, [inlinePoints, inlinePointId]);

    return (
        <div
            style={{
                backgroundColor: '#F7F7F7',
                padding: 16,
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Radio.Group
                value={inlinePointId}
                onChange={(e) => {
                    setInlinePointId(e.target.value);
                }}
                style={{ marginBottom: 16 }}
                disabled={disabled}
            >
                {inlinePoints.map((item) => (
                    <Radio.Button value={item.id}>{item.name}</Radio.Button>
                ))}
            </Radio.Group>

            <Select style={{ width: 200 }} value={value} onChange={onChange} disabled={disabled}>
                {options.map((item) => (
                    <Select.Option {...item}>
                        <Tooltip
                            placement="right"
                            title={
                                <div
                                    style={{ color: 'rgba(0, 0, 0, 0.45)', whiteSpace: 'pre-wrap' }}
                                >
                                    <Icon
                                        style={{ color: '#1A6EFF', marginRight: 8 }}
                                        type="InfoCircleFilled"
                                        antdIcon={true}
                                    />
                                    {item.desc}
                                </div>
                            }
                            color="#E6F3FF"
                        >
                            <div>{item.label}</div>
                        </Tooltip>
                    </Select.Option>
                ))}
            </Select>
        </div>
    );
};

export default Template;
